import { useState, useEffect } from 'react';

const useOrientation = () => {
    const getDeviceType2 = (screenSize) => {
        if (screenSize < 768) {
            return 'mobile';
        } else if (screenSize >= 768 && screenSize < 1024) {
            return 'tablet';
        } else {
            return 'desktop';
        }
    };

    const getDeviceType1 = (width, height) => {
        const userAgent = navigator.userAgent.toLowerCase();
        const screenSize = Math.max(width, height);
        // console.log('screenSize', screenSize);

        const isiPad = /ipad|macintosh/.test(userAgent) && navigator.maxTouchPoints > 1;
        const isiPhone = /iphone|ipod/.test(userAgent);
        const isAndroidTablet = /android/.test(userAgent) && !/mobile/.test(userAgent);

        // iPad Pro detection (larger screens)
        const isiPadPro = isiPad && (screenSize >= 1366 || window.screen.width >= 1024);
        // console.log('isiPadPro', isiPadPro, isiPad, isiPhone, isAndroidTablet, screenSize, userAgent, navigator);
        if (isiPadPro) {
            return 'ipadpro';
        } else if (isiPad || isAndroidTablet) {
            return 'tablet';
        } else if (isiPhone) {
            return 'mobile';
        } else if (screenSize <= 1368) {
            return 'tablet';
        } else if (screenSize > 1368 && screenSize < 1440) {
            return 'laptop';
        } else if (screenSize >= 1440) {
            return 'desktop';
        } else {
            return 'unknown';
        }
    };

    const getDeviceType = (width, height) => {
        const userAgent = navigator.userAgent.toLowerCase();
        const screenSize = Math.max(width, height);
        const isIOS = /ipad|iphone|ipod/.test(userAgent);
        const isMacDesktop = /macintosh/.test(userAgent) && navigator.maxTouchPoints === 0;
        const isAndroid = /android/.test(userAgent);

        // More accurate iPad detection
        const isIPad = () => {
            // Explicit iPad user agent
            if (/ipad/.test(userAgent)) return true;

            // Macintosh with touch could be iPad (but not desktop Safari)
            if (/macintosh/.test(userAgent) && navigator.maxTouchPoints > 0) {
                return true;
            }
            return false;
        };

        // Strict iPad Pro detection
        const isIPadPro = () => {
            if (!isIPad()) return false;

            // Check for iPad Pro screen dimensions
            const is12Inch = (width === 1024 && height === 1366) || (width === 1366 && height === 1024);
            const is11Inch = (width === 834 && height === 1194) || (width === 1194 && height === 834);

            return is12Inch || is11Inch;
        };

        // Android tablet detection
        const isAndroidTablet = isAndroid && !/mobile/.test(userAgent);

        // Desktop Safari on Mac will have macintosh but no touch points
        if (isMacDesktop) {
            return screenSize >= 1440 ? 'desktop' : 'laptop';
        } else if (isIPadPro()) {
            return 'ipadpro';
        } else if (isIPad() || isAndroidTablet) {
            // console.log('userAgent', userAgent, 'isIPad', isIPad(), 'isAndroidTablet', isAndroidTablet);
            return 'tablet';
        } else if (/iphone|ipod|android.*mobile|mobile/.test(userAgent)) {
            return 'mobile';
        }
        // Fallback to screen size detection for non-mobile devices
        else if (screenSize <= 1024) {
            return 'tablet';
        } else if (screenSize > 1024 && screenSize < 1440) {
            return 'laptop';
        } else {
            return 'desktop';
        }
    };

    const [orientation, setOrientation] = useState({
        isPortrait: window.innerHeight > window.innerWidth,
        deviceType: getDeviceType(window.screen.width, window.screen.height),
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        const handleResize = () => {
            const isPortrait = window.innerHeight > window.innerWidth;
            const deviceType = getDeviceType(window.screen.width, window.screen.height);
            setOrientation({ isPortrait, deviceType, width: window.innerWidth, height: window.innerHeight });
        };

        window.addEventListener('resize', handleResize);
        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    return orientation;
};

export default useOrientation;
